import { onDelegatedClick, initAllModules, quoteattr, onClick, debounce } from './functions.js';

export default function SignaturePadModule(element, args) {
    args = Object.assign({}, element.dataset, args);
    let qs = element.querySelector.bind(element);

    let signaturePad;

    let canvas      = qs('canvas');
    let clearBtn    = qs('.signbox__clear');
    let hiddenInput = qs('input[type=hidden]');
    
    function init() {

        resizeCanvas();
        signaturePad = new SignaturePad(canvas);

        if (hiddenInput.value) {
            signaturePad.fromDataURL(hiddenInput.value);
            hiddenInput.value = '';
        }

        
        bindEvents();
    }

    function resizeCanvas() {
        const ratio =  Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext('2d').scale(ratio, ratio);
        signaturePad && signaturePad.clear();
    }


    let data;
    function bindEvents() {
        onClick(clearBtn, event => {
            event.preventDefault();
            signaturePad.clear();
        });
        
        signaturePad.addEventListener('endStroke', function() {
            saveSign();
        });

        window.addEventListener('resize', debounce(function() {
            data = signaturePad.toDataURL();
            onWindowResize();
        }, 1000));

        console.log('bindEvents');
    }

    function onWindowResize() {

        console.log('onWindowResize');

        resizeCanvas();
        
        signaturePad.fromDataURL(data) 
    }

    function saveSign() {
        hiddenInput.value = signaturePad.toDataURL();
    }

    init();
    
    return this;

};